import React, {useEffect} from 'react';

import {getAccountTypes} from '../../../services/Api';
import {ErrorWarning} from '../../../shared/components/ErrorWarning';
import {useBankStore} from '../../../store/slices/bankStore';
import {useChatStore} from '../../../store/slices/chatStore';
import {useInteractionStore} from '../../../store/slices/interactionStore';
import {startScrollingChat} from '../../../utils';
import './BankAccountTypeReload.style.scss';

export const BankAccountTypeReload = () => {
  const setAccountTypeOptions = useBankStore(
    (state) => state.setAccountTypeOptions
  );
  const responseTypeChange = useChatStore((state) => state.responseTypeChange);
  const setDotTyping = useInteractionStore((state) => state.setDotTyping);

  const getAccountTypesRequest = () => {
    setDotTyping(true);
    getAccountTypes().then((response) => {
      setDotTyping(false);
      setAccountTypeOptions(response.data);
      responseTypeChange('disabled');
      startScrollingChat(0);
    });
  };

  useEffect(() => {
    getAccountTypesRequest();
  }, []);

  return (
    <div className="warning-content">
      <ErrorWarning
        htmlId="repeat-request-banks-account-types"
        request={getAccountTypesRequest}
      />
    </div>
  );
};
